import React, { useEffect, useState } from "react";
import config from "lib/fr-config";
import { makeStyles } from "@material-ui/core/styles";
import { useCookies } from "react-cookie";
import { withStore } from "store/storeHandler";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";

const colorCss = config.css.color;

const MAX_DISPLAY_COUNT = 2;

const useStyles = makeStyles(() => ({
  tooltip: {
    // borderRadius: 0,
    fontSize: 12,
    margin: "8px 0",
    padding: "4px 8px",
    lineHeight: 1.5,
    display: "flex",
    maxWidth: 250
  },
  tooltipPrimary: {
    // borderRadius: 0,
    fontSize: 12,
    margin: "8px 0",
    padding: "4px 8px",
    lineHeight: 1.5,
    display: "flex",
    maxWidth: 250,
    backgroundColor: colorCss.colorOfTooltipPrimary
  },
  arrowPrimary: {
    color: colorCss.colorOfTooltipPrimary
  },
  popperNormal: {
    zIndex: 990
  },
  popperOnModal: {
    zIndex: 2000
  }
}));

CommonGuideTooltipView.propTypes = {
  needClose: PropTypes.bool.isRequired,
  /** true 값이 되면 툴팁이 사라진다. 한번이라도 true가 되면 툴팁은 다시 표시되지 않는다. */

  needCountUp: PropTypes.bool.isRequired,
  /** 이 컴포넌트의 종료시접에 값이 true라면 해당 쿠키의 값이 +1 된다. */

  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  placement: PropTypes.oneOf([
    "top",
    "bottom",
    "top-start",
    "top-end",
    "bottom-end"
  ]),
  arrow: PropTypes.bool,
  backgroundDesign: PropTypes.oneOf(["default", "primary"]),
  displayOnModal: PropTypes.bool,

  /**
   * displayForGuest 값이
   *    true  라면 guest일 경우 쿠키 작성되지 않으며 툴팁이 무제한 출력된다.
   *    false 라면 guest일 경우 툴팁이 출력되지 않는다.
   * */
  displayForGuest: PropTypes.bool,

  /**
   * 로그인한 회원의 경우 하단의 값에 맞는 count만큼 툴팁이 출력된다.
   * 단, cookieName이 없다면 툴팁은 출력되지 않는다.*/
  cookieName: PropTypes.string,
  maxDisplayCount: PropTypes.number
};

CommonGuideTooltipView.defaultProps = {
  placement: "bottom",
  arrow: false,
  backgroundDesign: "default",
  displayOnModal: false,
  displayForGuest: false,
  cookieName: null,
  maxDisplayCount: MAX_DISPLAY_COUNT
};

function CommonGuideTooltipView(props) {
  const {
    needClose,
    needCountUp,
    message,
    placement,
    maxDisplayCount,
    arrow,
    backgroundDesign,
    displayForGuest,
    cookieName,
    displayOnModal,
    children,
    hasLoggedIn
  } = props;
  const [open, setOpen] = useState(false);

  const [cookies, setCookies] = useCookies([cookieName]);

  const classes = useStyles();

  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    setClose();
  }, [needClose]);
  useEffect(() => {
    return () => {
      setCountUp();
    };
  }, [needCountUp]);

  const init = () => {
    if (!hasLoggedIn) {
      if (displayForGuest) setOpen(true);
      else return null;
    } else {
      if (!cookieName) return null;
      else if (getCookieNum() < maxDisplayCount && !needClose) setOpen(true);
    }
  };

  const setClose = () => {
    if (needClose && open) setOpen(false);
  };

  const setCountUp = () => {
    if (!hasLoggedIn || !cookieName) return null;

    const cookieNum = getCookieNum();
    if (cookieNum < maxDisplayCount && needCountUp) {
      setCookieNum(cookieNum + 1);
    }
  };

  const getCookieNum = () => {
    const rawCookieValue = cookies[cookieName];
    let cookieNum;

    if (isNaN(Number(rawCookieValue))) {
      setCookieNum(0);
      cookieNum = 0;
    } else {
      cookieNum = Number(rawCookieValue);
    }

    return cookieNum;
  };

  const setCookieNum = cookieNum => {
    setCookies(cookieName, cookieNum, {
      path: "/",
      maxAge: 2592000
    });
  };

  return (
    <Tooltip
      classes={{
        tooltip:
          backgroundDesign === "primary"
            ? classes.tooltipPrimary
            : classes.tooltip,
        popper: displayOnModal ? classes.popperOnModal : classes.popperNormal,
        arrow: backgroundDesign === "primary" ? classes.arrowPrimary : undefined
      }}
      arrow={arrow}
      open={open}
      title={<span style={{ textAlign: "center" }}>{message}</span>}
      placement={placement}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      TransitionProps={{ timeout: 800 }}
    >
      {children}
    </Tooltip>
  );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] }
})(CommonGuideTooltipView);
